<div class="row">
  <div class="col-12 col-md-6">
    <h4 translate>DELIVERY_ADDRESS</h4>
    <div class="form-group">
      <label for="ordlevadr1" class="control-label" translate>OH_ORDLEVADR1</label>
      <input
        type="text"
        class="form-control form-control-sm"
        id="ordlevadr1"
        [value]="checkout.extra.procargs.ordlevadr1 || ''"
        readonly
      />
    </div>
    <div class="form-group">
      <label for="ordlevadr2" class="control-label" translate>OH_ORDLEVADR2</label>
      <input
        type="text"
        class="form-control form-control-sm"
        id="ordlevadr2"
        [value]="checkout.extra.procargs.ordlevadr2 || ''"
        readonly
      />
    </div>
    <div class="form-group">
      <label for="ordlevadr3" class="control-label" translate>OH_ORDLEVADR3</label>
      <input
        type="text"
        class="form-control form-control-sm"
        id="ordlevadr3"
        [value]="checkout.extra.procargs.ordlevadr3 || ''"
        readonly
      />
    </div>
    <div class="form-group">
      <label for="ordlevadr4" class="control-label" translate>OH_ORDLEVADR4</label>
      <input
        type="text"
        class="form-control form-control-sm"
        id="ordlevadr4"
        [value]="checkout.extra.procargs.ordlevadr4 || ''"
        readonly
      />
    </div>
    <lib-meta-select-input
      [(ngModel)]="checkout.extra.procargs.ordlevadrlandskod"
      table="xr"
      metaId="landskod"
      metaDisplay="land"
      [disabled]="true"
    >
    </lib-meta-select-input>
  </div>
  <div class="col-12 col-md-6" *ngIf="customer">
    <h4 translate>INVOICE_ADDRESS</h4>
    <div class="form-group">
      <label for="billingFtgnr" class="control-label" translate>CUSTOMER_ID</label>
      <input
        type="text"
        class="form-control form-control-sm"
        id="billingFtgnr"
        [value]="customer.extra._billing.ftgnr || ''"
        readonly
      />
    </div>
    <div class="form-group">
      <label for="billingFtgnamn" class="control-label" translate>FTGNAMN</label>
      <input
        type="text"
        class="form-control form-control-sm"
        id="billingFtgnamn"
        [value]="customer.extra._billing.ftgnamn || ''"
        readonly
      />
    </div>
    <div class="form-group">
      <label for="billingFtgpostadr2" class="control-label" translate>FTGPOSTADR2</label>
      <input
        type="text"
        class="form-control form-control-sm"
        id="billingFtgpostadr2"
        [value]="customer.extra._billing.ftgpostadr2 || ''"
        readonly
      />
    </div>
    <div class="form-group">
      <label for="billingFtgpostnr" class="control-label" translate>FTGPOSTNR</label>
      <input
        type="text"
        class="form-control form-control-sm"
        id="billingFtgpostnr"
        [value]="customer.extra._billing.ftgpostnr || ''"
        readonly
      />
    </div>
    <div class="form-group">
      <label for="billingFtgpostadr3" class="control-label" translate>FTGPOSTADR3</label>
      <input
        type="text"
        class="form-control form-control-sm"
        id="billingFtgpostadr3"
        [value]="customer.extra._billing.ftgpostadr3 || ''"
        readonly
      />
    </div>
    <lib-meta-select-input
      [(ngModel)]="customer.extra._billing.landskod"
      table="xr"
      metaId="landskod"
      metaDisplay="land"
      [disabled]="true"
    >
    </lib-meta-select-input>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <h4 translate>CONDITIONS</h4>
  </div>
  <div class="col-12 col-md-6">
    <lib-meta-select-input
      [(ngModel)]="checkout.extra.procargs.levsattkod"
      table="x2f"
      metaId="levsattkod"
      metaDisplay="levsattbeskr"
      [disabled]="true"
    >
    </lib-meta-select-input>
    <lib-meta-select-input
      [(ngModel)]="checkout.extra.procargs.levvillkkod"
      table="x2e"
      metaId="levvillkkod"
      metaDisplay="levvillkbeskr"
      [disabled]="true"
    >
    </lib-meta-select-input>
  </div>
  <div class="col-12 col-md-6">
    <lib-meta-select-input
      [(ngModel)]="checkout.extra.oh.betkod"
      table="x2"
      metaId="betkod"
      metaDisplay="betvillbeskr"
      [disabled]="true"
    >
    </lib-meta-select-input>
    <lib-meta-select-input
      [(ngModel)]="checkout.extra.procargs.saljare"
      table="salj"
      metaId="saljare"
      metaDisplay="saljarenamn"
      [disabled]="true"
    >
    </lib-meta-select-input>
  </div>
</div>

<div *ngIf="productsMap && pricesMap" class="row">
  <div class="col-12">
    <div class="table-responsive">
      <table class="table table-striped">
        <thead class="table-header1">
          <tr>
            <th colspan="10">
              <h4 translate>ROWS</h4>
            </th>
          </tr>
        </thead>
        <thead class="table-header1">
          <tr>
            <th translate>PRODUCT_ID</th>
            <th translate>NAME</th>
            <th translate>ESTIMATED_DELIVERY_DATE</th>
            <th translate>QUANTITY</th>
            <th translate>LISTPRIS</th>
            <th>
              <span *ngIf="sales" class="d-table-cell" translate>DISCOUNT</span>
            </th>
            <th translate>NET_PRICE</th>
            <th translate>SPIKES</th>
            <th translate>SIPING</th>
            <th translate>TOTAL</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of allRows">
            <td>{{ row.id }}</td>
            <td>
              {{ productsMap[row.id].name }}
              <div *ngIf="mappedProductsAddons && mappedProductsAddons.has(row.id)">
                <div class="pt-1 text-truncate small" *ngFor="let addonProduct of mappedProductsAddons.get(row.id)">
                  <i class="fas fa-plus checkout-addon-icon"></i>&nbsp;{{ addonProduct.addon.id }} -
                  {{ addonProduct.addon.name }}
                </div>
              </div>
            </td>
            <td>
              <span *ngIf="row.extra.orp && row.extra.orp.ordberlevdat; else orderHeadDate">{{
                row.extra.orp.ordberlevdat | date: 'yyyy-MM-dd'
              }}</span>
              <ng-template #orderHeadDate>
                <span *ngIf="checkout.extra.oh.ordberlevdat; else defaultDate">{{
                  checkout.extra.oh.ordberlevdat | date: 'yyyy-MM-dd'
                }}</span>
              </ng-template>
              <ng-template #defaultDate>{{ today | date: 'yyyy-MM-dd' }}</ng-template>
            </td>
            <td>{{ row.quantity }}</td>
            <td>
              <span *ngIf="pricesMap">
                <lib-price
                  [price]="pricesMap[row.id].cartRowUnitPrice.value"
                  [currency]="pricesMap[row.id].cartRowUnitPrice.currencyCode"
                ></lib-price>
                <div *ngIf="mappedProductsAddons && mappedProductsAddons.has(row.id)">
                  <div
                    class="pt-1 text-truncate small"
                    *ngFor="let addonProductPrice of mappedProductsAddons.get(row.id)"
                  >
                    <lib-price
                      [price]="addonProductPrice.price.customerGrossPrice.value"
                      [currency]="addonProductPrice.price.customerGrossPrice.currencyCode"
                    ></lib-price>
                  </div>
                </div>
              </span>
            </td>
            <td class="d-table-cell">
              <span [class.d-none]="hidePrice" *ngIf="sales && pricesMap && pricesMap[row.id].cartRowDiscountPercent"
                >{{ pricesMap[row.id].cartRowDiscountPercent | number: '1.0-2' }} %</span
              >
            </td>
            <td>
              <span *ngIf="pricesMap">
                <lib-price
                  [price]="pricesMap[row.id].cartRowUnitPriceInclRowDiscount.value"
                  [currency]="pricesMap[row.id].customerGrossPrice.currencyCode"
                  [class.d-none]="hidePrice"
                ></lib-price>
                <div *ngIf="mappedProductsAddons && mappedProductsAddons.has(row.id)">
                  <div
                    class="pt-1 text-truncate small"
                    *ngFor="let addonProductPrice of mappedProductsAddons.get(row.id)"
                  >
                    <lib-price
                      [price]="addonProductPrice.price.customerNetPrice.value"
                      [currency]="addonProductPrice.price.customerNetPrice.currencyCode"
                      [class.d-none]="hidePrice"
                    ></lib-price>
                  </div>
                </div>
              </span>
            </td>
            <td>
              <span translate>{{ row.extra._colmecDubbingSelected ? 'YES' : 'NO' }}</span>
            </td>
            <td>
              <span translate>{{ row.extra._colmecSipingSelected ? 'YES' : 'NO' }}</span>
            </td>
            <td>
              <span *ngIf="pricesMap">
                <lib-price
                  [class.d-none]="hidePrice"
                  [price]="pricesMap[row.id].cartRowTotalPriceInclRowDiscount.value"
                  [currency]="pricesMap[row.id].cartRowTotalPriceInclRowDiscount.currencyCode"
                ></lib-price>
              </span>
            </td>
          </tr>
        </tbody>
        <thead *ngIf="extras.totalQty > 0">
          <tr>
            <th colspan="10" translate>
              <h4 translate>ADDITIONAL_COSTS</h4>
            </th>
          </tr>
        </thead>
        <thead class="table-header3" *ngIf="extras.totalQty > 0">
          <tr>
            <th colspan="3" translate>CATEGORY</th>
            <th colspan="6" translate>QUANTITY</th>
            <th translate>TOTAL</th>
          </tr>
        </thead>
        <tbody *ngIf="extras.totalQty > 0">
          <tr *ngIf="extras.spikes.totalQty > 0">
            <td colspan="3" translate>SPIKES</td>
            <td colspan="6">
              {{ extras.spikes.totalQty }}
            </td>
            <td>
              <lib-price [price]="extras.spikes.totalValue" [currency]="extras.spikes.currencyCode"></lib-price>
            </td>
          </tr>
          <tr *ngIf="extras.siping.totalQty > 0">
            <td colspan="3" translate>SIPING</td>
            <td colspan="6">
              {{ extras.siping.totalQty }}
            </td>
            <td>
              <lib-price [price]="extras.siping.totalValue" [currency]="extras.siping.currencyCode"></lib-price>
            </td>
          </tr>
          <!-- <tr *ngIf="extras.expressFreight.totalQty > 0">
            <td colspan="3" translate>EXPRESS_FREIGHT</td>
            <td colspan="6">
              {{ extras.expressFreight.totalQty }}
            </td>
            <td>
              <lib-price
                [price]="extras.expressFreight.totalValue"
                [currency]="extras.expressFreight.currencyCode"
              ></lib-price>
            </td>
          </tr> -->
        </tbody>
      </table>
    </div>
  </div>
  <hr />
</div>

<div class="row" *ngIf="productsMap && pricesMap">
  <div class="col-12">
    <h4 class="text-right" translate>TOTAL : <lib-price [price]="totalValue" [currency]="'SEK'"></lib-price></h4>
  </div>
</div>
<div class="row" *ngIf="productsMap && pricesMap">
  <div class="col-md-6">
    <div class="alert alert-light text-right" role="alert">
      <span
        >{{ 'COLMEC_PLACE_ORDER_TERMS_AND_CONDITIONS' | translate }}
        <strong>
          <a class="alert-link" download href="./assets/documents/allmanna_villkor.pdf">{{
            'COLMEC_PLACE_ORDER_TERMS_AND_CONDITIONS_LINK' | translate
          }}</a>
        </strong>
      </span>
    </div>
  </div>
</div>
